var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-cart",
      class: {
        "sidebar-cart--inline": _vm.isInline,
        "sidebar-cart--outside": !_vm.isInline,
        "sidebar-cart--restricted":
          _vm.hasFeature("FEATURE_GROUP_ORDERS") &&
          _vm.cartIsGroupOrder &&
          !_vm.groupOrderIsOwner
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "sidebar-cart__wrapper",
          class: {
            "sidebar-cart--editable": _vm.isEditableEnhanced
          }
        },
        [
          _c(
            "div",
            { staticClass: "sidebar-cart__inner" },
            [
              _c("div", { staticClass: "sidebar-cart__title" }, [
                _c("ul", { staticClass: "sidebar-cart__info" }, [
                  _c(
                    "li",
                    { staticClass: "sidebar-cart__info-item" },
                    [
                      _vm.shippingMethod && _vm.shippingMethod.code
                        ? _c(
                            _vm.shippingMethodIconComponent(
                              _vm.shippingMethod.code
                            ),
                            {
                              tag: "component",
                              staticClass: "sidebar-cart__info-item-icon"
                            }
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.shippingMethod
                        ? _c("span", {
                            staticClass: "sidebar-cart__info-item-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.shippingMethod.name)
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "sidebar-cart__info-item" },
                    [
                      _c("SVGLocation", {
                        staticClass: "sidebar-cart__info-item-icon"
                      }),
                      _vm._v(" "),
                      _vm.displayLocation
                        ? _c("span", {
                            staticClass: "sidebar-cart__info-item-text",
                            domProps: { innerHTML: _vm._s(_vm.displayLocation) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isIndining && !_vm.cartIsGroupOrder
                        ? _c("Button", {
                            staticClass: "sidebar-cart__info-item-edit",
                            attrs: {
                              icon: "edit",
                              type: "button",
                              level: "tertiary"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onLocationEdit.apply(null, arguments)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.deliveryTimeEnhanced && !_vm.timeDisabled
                    ? _c(
                        "li",
                        { staticClass: "sidebar-cart__info-item" },
                        [
                          _c("SVGClock", {
                            staticClass: "sidebar-cart__info-item-icon"
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "sidebar-cart__info-item-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.deliveryTimeEnhanced)
                            }
                          }),
                          _vm._v(" "),
                          !_vm.isIndining && !_vm.timeLocked
                            ? _c("Button", {
                                staticClass: "sidebar-cart__info-item-edit",
                                attrs: {
                                  icon: "edit",
                                  type: "button",
                                  level: "tertiary"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.onTimeEdit.apply(null, arguments)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sidebar-cart__title-close",
                    on: { click: _vm.close }
                  },
                  [_c("SVGClose")],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.showContinue
                ? _c(
                    "div",
                    { staticClass: "sidebar-cart__continue" },
                    [
                      _c("Button", {
                        staticClass: "sidebar-cart__continue-button",
                        attrs: {
                          text: _vm.$t("cart.continueShopping"),
                          level: "tertiary",
                          type: "button",
                          arrow: true
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.backToShop.apply(null, arguments)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.totalItemsWithoutAdditional > 0 && !_vm.isCartValidForCheckout
                ? _c("div", {
                    staticClass: "sidebar-cart__warning",
                    domProps: { innerHTML: _vm._s(_vm.minCartPriceMessage) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditableParticipant && !_vm.showContinue
                ? _c("SidebarCartCrossSell", {
                    attrs: {
                      "cross-sell": _vm.cartCrossSell,
                      "locked-products": _vm.lockedProducts
                    },
                    on: {
                      config: function($event) {
                        return _vm.$emit("config", $event)
                      },
                      addToCart: function($event) {
                        return _vm.$emit("addToCart", $event)
                      },
                      notify: _vm.onNotifyProductAdded
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.totalItemsWithoutAdditional ||
              (_vm.hasFeature("FEATURE_GROUP_ORDERS") && _vm.cartIsGroupOrder)
                ? [
                    _c("div", { staticClass: "sidebar-cart__tabs" }, [
                      _c("button", {
                        staticClass: "sidebar-cart__tab",
                        class: {
                          "sidebar-cart__tab--active":
                            _vm.activeTab == "overview"
                        },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("cart.tabOverview"))
                        },
                        on: {
                          click: function($event) {
                            return _vm.onTabClick("overview")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "sidebar-cart__tab",
                        class: {
                          "sidebar-cart__tab--active": _vm.activeTab == "info"
                        },
                        domProps: { innerHTML: _vm._s(_vm.$t("cart.tabInfo")) },
                        on: {
                          click: function($event) {
                            return _vm.onTabClick("info")
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.activeTab == "overview"
                      ? _c(
                          "div",
                          { staticClass: "sidebar-cart__tab-content" },
                          [
                            _c(
                              "ul",
                              { staticClass: "sidebar-cart__list" },
                              [
                                _vm.hasFeature("FEATURE_GROUP_ORDERS") &&
                                _vm.cartIsGroupOrder
                                  ? _vm._l(
                                      _vm.groupOrderParticipantsEnhanced,
                                      function(participant) {
                                        return _c(
                                          "li",
                                          {
                                            key: participant.id,
                                            staticClass:
                                              "sidebar-cart__list-participant"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sidebar-cart__list-participant-header"
                                              },
                                              [
                                                participant.ready
                                                  ? _c("SVGSmallCheckmark", {
                                                      staticClass:
                                                        "sidebar-cart__list-participant-ready"
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("div", {
                                                  directives: [
                                                    {
                                                      name: "sanitize",
                                                      rawName: "v-sanitize",
                                                      value: participant.name,
                                                      expression:
                                                        "participant.name"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "sidebar-cart__list-participant-name"
                                                }),
                                                _vm._v(" "),
                                                _vm.groupOrderIsOwner ||
                                                (_vm.groupOrderParticipant &&
                                                  participant.id ===
                                                    _vm.groupOrderParticipant
                                                      .id)
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "sidebar-cart__list-participant-edit",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.editGroupOrderParticipant(
                                                              participant
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_c("SVGEdit")],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.groupOrderIsOwner &&
                                                !participant.isOwner
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "sidebar-cart__list-participant-remove",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeGroupOrderParticipant(
                                                              participant
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_c("SVGClose")],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "sidebar-cart__list"
                                              },
                                              [
                                                _vm._l(
                                                  participant.items,
                                                  function(item) {
                                                    return _c(
                                                      _vm.itemType(item),
                                                      {
                                                        key: item.id,
                                                        tag: "component",
                                                        attrs: {
                                                          item: item,
                                                          locked:
                                                            _vm.lockedItems[
                                                              item.id
                                                            ],
                                                          editable:
                                                            _vm.isEditableParticipant,
                                                          restricted:
                                                            !participant.isCurrentUser &&
                                                            !_vm.groupOrderIsOwner,
                                                          outside:
                                                            _vm.showContinue
                                                        },
                                                        on: {
                                                          sub: function(
                                                            $event
                                                          ) {
                                                            return _vm.onSub(
                                                              item
                                                            )
                                                          },
                                                          add: function(
                                                            $event
                                                          ) {
                                                            return _vm.onAdd(
                                                              item
                                                            )
                                                          },
                                                          edit: function(
                                                            $event
                                                          ) {
                                                            return _vm.onChildProductModal(
                                                              item
                                                            )
                                                          },
                                                          remove: function(
                                                            $event
                                                          ) {
                                                            return _vm.onDelete(
                                                              item
                                                            )
                                                          },
                                                          copy: function(
                                                            $event
                                                          ) {
                                                            return _vm.onCopy(
                                                              item
                                                            )
                                                          },
                                                          notes: function(
                                                            $event
                                                          ) {
                                                            return _vm.onNotes(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      }
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                !participant.items.length
                                                  ? _c("li", {
                                                      staticClass:
                                                        "sidebar-cart__list-item sidebar-cart__list-item--empty",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "cart.groupOrder.noItems"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  : [
                                      _vm._l(
                                        _vm.itemsWithoutAdditional,
                                        function(item) {
                                          return _c(_vm.itemType(item), {
                                            key: item.id,
                                            tag: "component",
                                            attrs: {
                                              item: item,
                                              locked: _vm.lockedItems[item.id],
                                              editable:
                                                _vm.isEditableParticipant,
                                              outside: _vm.showContinue
                                            },
                                            on: {
                                              sub: function($event) {
                                                return _vm.onSub(item)
                                              },
                                              add: function($event) {
                                                return _vm.onAdd(item)
                                              },
                                              edit: function($event) {
                                                return _vm.onChildProductModal(
                                                  item
                                                )
                                              },
                                              remove: function($event) {
                                                return _vm.onDelete(item)
                                              },
                                              copy: function($event) {
                                                return _vm.onCopy(item)
                                              },
                                              notes: function($event) {
                                                return _vm.onNotes(item)
                                              }
                                            }
                                          })
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.totalItemsWithoutAdditional <= 0
                                        ? _c("li", {
                                            staticClass:
                                              "sidebar-cart__list-item sidebar-cart__list-item--empty",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t("cart.warningCartEmpty")
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.hasFeature("FEATURE_ADDITIONALPRODUCTS") &&
                            _vm.additionalItemsAvailable &&
                            _vm.totalItemsWithoutAdditional
                              ? _c("SidebarCartAdditionalProducts", {
                                  attrs: {
                                    "additional-items": _vm.additionalItems,
                                    "additional-items-price":
                                      _vm.additionalItemsPrice,
                                    "additional-open": _vm.additionalOpen
                                  },
                                  on: {
                                    toggle: _vm.onAdditionalToggle,
                                    edit: _vm.onAdditionalEdit
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeTab == "info"
                      ? _c(
                          "div",
                          { staticClass: "sidebar-cart__tab-content" },
                          [
                            _vm.hasFeature("FEATURE_NUTRITION_DETAILS")
                              ? _c("SidebarCartItemsInfo")
                              : _c(
                                  "div",
                                  { staticClass: "sidebar-cart__details" },
                                  [
                                    _c("h3", {
                                      staticClass:
                                        "sidebar-cart__details-title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("cart.details.tempTitle")
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "sidebar-cart__details-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("cart.details.tempText")
                                        )
                                      }
                                    })
                                  ]
                                )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : [
                    _c("ul", { staticClass: "sidebar-cart__list" }, [
                      _c("li", {
                        staticClass:
                          "sidebar-cart__list-item sidebar-cart__list-item--empty",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("cart.warningCartEmpty"))
                        }
                      })
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.totalItemsWithoutAdditional
            ? _c(
                "div",
                { staticClass: "sidebar-cart__summary" },
                [
                  _vm.showSubtotal
                    ? _c(
                        "div",
                        { staticClass: "sidebar-cart__summary-subtotal" },
                        [
                          _c("div", {
                            staticClass: "sidebar-cart__summary-subtotal-title",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("cart.subtotal"))
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "sidebar-cart__summary-subtotal-price",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.fwgpricecent(
                                  _vm.subtotal,
                                  "short"
                                )
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.discounts, function(discount) {
                    return _c(
                      "div",
                      {
                        key: discount.name,
                        staticClass: "sidebar-cart__summary-row"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-row-info" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sidebar-cart__summary-row-info-title"
                              },
                              [
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(discount.name) }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        discount.removable !== false &&
                        !_vm.promotionCouponLocked &&
                        !_vm.promotionCouponDisabled
                          ? _c(
                              "button",
                              {
                                staticClass: "sidebar-cart__summary-row-remove",
                                on: {
                                  click: function($event) {
                                    return _vm.$store.dispatch(
                                      "cart/removeCoupon"
                                    )
                                  }
                                }
                              },
                              [_c("SVGClose")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "sidebar-cart__summary-row-price",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                discount.amount.current,
                                "short"
                              )
                            )
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.deliveryPrice > 0
                    ? _c("div", { staticClass: "sidebar-cart__summary-row" }, [
                        _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-row-info" },
                          [
                            _c("div", {
                              staticClass:
                                "sidebar-cart__summary-row-info-title",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("cart.deliveryFee"))
                              }
                            }),
                            _vm._v(" "),
                            _vm.minCartFreePrice > 0
                              ? _c("div", {
                                  staticClass:
                                    "sidebar-cart__summary-row-info-meta",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("cart.freeDeliveryThreshold", {
                                        price: _vm.$options.filters.fwgpricecent(
                                          _vm.minCartFreePrice
                                        )
                                      })
                                    )
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "sidebar-cart__summary-row-price",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                _vm.deliveryPrice,
                                "short"
                              )
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCo2 &&
                  _vm.cartChannelHasCo2Compensation &&
                  _vm.cartCo2Compensation &&
                  _vm.cartCo2CompensationAmount
                    ? _c("div", { staticClass: "sidebar-cart__summary-row" }, [
                        _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-row-info" },
                          [
                            _c("div", {
                              staticClass:
                                "sidebar-cart__summary-row-info-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("cart.co2Compensation")
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "sidebar-cart__summary-row-price",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                _vm.cartCo2CompensationAmount,
                                "short"
                              )
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTip && _vm.cartTip
                    ? _c("div", { staticClass: "sidebar-cart__summary-row" }, [
                        _c(
                          "div",
                          { staticClass: "sidebar-cart__summary-row-info" },
                          [
                            _c("div", {
                              staticClass:
                                "sidebar-cart__summary-row-info-title",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("cart.tip"))
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "sidebar-cart__summary-row-price",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                _vm.cartTip,
                                "short"
                              )
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "sidebar-cart__summary-total" }, [
                    _c("div", {
                      staticClass: "sidebar-cart__summary-total-title",
                      domProps: { innerHTML: _vm._s(_vm.$t("cart.total")) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "sidebar-cart__summary-total-price",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(
                            _vm.displayTotal,
                            "short"
                          )
                        )
                      }
                    })
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.cartIsGroupOrder || _vm.groupOrderIsOwner
            ? _c("Button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.totalItemsWithoutAdditional > 0,
                    expression: "totalItemsWithoutAdditional > 0"
                  }
                ],
                staticClass: "sidebar-cart__submit",
                attrs: {
                  disabled: _vm.loading || !_vm.isCartValidForCheckout,
                  text: _vm.$t("cart.orderButton"),
                  level: "primary",
                  type: "button"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.gotoCheckout.apply(null, arguments)
                  }
                }
              })
            : _c("Button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.groupOrderParticipantEnhanced &&
                      _vm.groupOrderParticipantEnhanced.items.length,
                    expression:
                      "groupOrderParticipantEnhanced && groupOrderParticipantEnhanced.items.length"
                  }
                ],
                staticClass: "sidebar-cart__ready",
                attrs: {
                  disabled: _vm.loading,
                  text:
                    _vm.groupOrderParticipantEnhanced &&
                    _vm.groupOrderParticipantEnhanced.ready
                      ? _vm.$t("cart.groupOrder.unReadyButton")
                      : _vm.$t("cart.groupOrder.readyButton"),
                  level: "primary",
                  type: "button"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onParticipantReady.apply(null, arguments)
                  }
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "sidebar-cart__backdrop",
        on: { click: _vm.close }
      }),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_ADDITIONALPRODUCTS")
        ? _c(
            "Modal",
            {
              ref: "modal",
              attrs: {
                "overlay-type": "additional-products",
                "html-classes": ["hide--header", "show--modal"],
                "soft-close": ""
              },
              on: {
                close: _vm.onModalClose,
                softclose: _vm.onAdditionalEditSoftClose
              }
            },
            [
              _c("OverlayAdditionalProducts", {
                ref: "overlayAdditionalProducts",
                on: { close: _vm.onAdditionalEditClose }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "timeModal",
          attrs: {
            "overlay-type": "time-change",
            "html-classes": ["hide--header", "show--modal"],
            narrow: ""
          },
          on: { close: _vm.onModalClose }
        },
        [
          _c("OverlayTimeEdit", {
            on: { close: _vm.onTimeEditClose, change: _vm.onTimeChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "locationModal",
          attrs: {
            "overlay-type": "location-change",
            "html-classes": ["hide--header", "show--modal"],
            narrow: ""
          },
          on: { close: _vm.onModalClose }
        },
        [
          _c("OverlayLocationEdit", {
            on: {
              cancel: _vm.onLocationEditClose,
              confirm: _vm.onLocationEditConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "chartChangeModal",
          attrs: {
            "overlay-type": "cart-change",
            "html-classes": ["hide--header", "show--modal"],
            narrow: ""
          },
          on: { close: _vm.onModalClose }
        },
        [
          _c("OverlayCartChange", {
            attrs: { "changed-items": _vm.cartChangedItems },
            on: { confirm: _vm.onCartChangeClose }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "itemNotesModal",
          attrs: {
            "overlay-type": "cart-item-notes",
            "html-classes": ["hide--header", "show--modal"],
            narrow: ""
          },
          on: { close: _vm.onModalClose }
        },
        [
          _c("div", { staticClass: "overlay-dialog" }, [
            _vm.notesItem
              ? _c(
                  "form",
                  {
                    staticClass: "sidebar-cart__notes-form",
                    on: { submit: _vm.onNotesSubmit }
                  },
                  [
                    _c("h2", {
                      staticClass: "sidebar-cart__notes-form-title",
                      domProps: { innerHTML: _vm._s(_vm.notesItem.name) }
                    }),
                    _vm._v(" "),
                    _vm.notesItem.variant
                      ? _c("h3", {
                          staticClass: "sidebar-cart__notes-form-subtitle",
                          domProps: { innerHTML: _vm._s(_vm.notesItem.variant) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("FormInputTextarea", {
                      attrs: {
                        placeholder: _vm.$t("forms.labels.notes"),
                        label: _vm.$t("forms.labels.notes")
                      },
                      model: {
                        value: _vm.notesItem.notes,
                        callback: function($$v) {
                          _vm.$set(_vm.notesItem, "notes", $$v)
                        },
                        expression: "notesItem.notes"
                      }
                    }),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: {
                        text: _vm.$t("cart.notes.saveButton"),
                        level: "primary",
                        type: "submit"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_GROUP_ORDERS")
        ? _c("Modal", {
            ref: "groupOrderModal",
            attrs: {
              "overlay-type": "group-order-edit",
              "html-classes": ["hide--header", "show--modal"],
              narrow: ""
            },
            on: { close: _vm.onModalClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var closeModal = ref.closeModal
                    return [
                      _c("OverlayGroupOrderForm", {
                        attrs: {
                          title: _vm.$t("cart.groupOrder.edit.title"),
                          name: _vm.groupOrderForm.name,
                          "button-text": _vm.$t(
                            "cart.groupOrder.edit.saveButton"
                          ),
                          loading: _vm.loading
                        },
                        on: {
                          "cancel:grouporder": closeModal,
                          "submit:grouporder": _vm.onGroupOrderEditSubmit
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              1806844673
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }